import { render, staticRenderFns } from "./red.vue?vue&type=template&id=2fd96526&scoped=true&lang=pug&"
import script from "./red.vue?vue&type=script&lang=js&"
export * from "./red.vue?vue&type=script&lang=js&"
import style0 from "./red.vue?vue&type=style&index=0&id=2fd96526&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd96526",
  null
  
)

export default component.exports